import { orderBy } from 'es-toolkit'
import { useTranslation } from 'react-i18next'
import { GenericCombobox, NON_EU_COUNTRIES } from '@/common'

export default function NonEuCountrySelector({
  label,
  value,
  onChange,
  tooltip
}: {
  label: string
  value: string
  onChange: (value: string) => void
  tooltip?: string
}) {
  const { t } = useTranslation()
  const placeOfRegistrationOptions = orderBy(
    NON_EU_COUNTRIES.map(country => ({
      label: t(`countriesByIsoAlpha2:${country.value}`),
      value: country.value
    })),
    [option => option.label.toLowerCase().normalize('NFKD')],
    ['asc']
  )

  const selectedItem = placeOfRegistrationOptions.find(option => option.value === value) || null

  return (
    <GenericCombobox
      label={label}
      value={selectedItem}
      onChange={evt => onChange(evt?.value || '')}
      items={placeOfRegistrationOptions}
      tooltip={tooltip}
    />
  )
}
